import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class TermsOfUseContent extends React.Component{

    constructor(){
        super();

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
        
                this.setState({settings:JSON.parse(localStorage.getItem("settings"))});
                this.setState({content:JSON.parse(localStorage.getItem("content"))[1]});
                this.setState({page_content:JSON.parse(localStorage.getItem("page_content"))});
                this.setState({loading:0})
            
    }


    render()
    { 
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
         <div class="ul-inner-page-container my-0">
            <section class="ul-about">
                <div class="row row-cols-md-2 row-cols-1 align-items-center ul-bs-row">
                    
                    <div class="col">
                        <div class="ul-about-txt">
                            <span class="ul-section-sub-title">{this.state.content.title}</span>
                            <h2 class="ul-section-title">{this.state.content.subtitle}</h2>
                            <p><div dangerouslySetInnerHTML={{ __html: this.state.content.body}} />  </p>
                        </div>
                    </div>

                     
                    <div class="col">
                        <div class="ul-TermsOfUse-img"><img src={this.state.content.image} alt={this.state.content.title}/></div>
                    </div>
                </div>
            </section>
        </div>
    );
}

}

export default TermsOfUseContent;